import service from './request';
import type { FaqEntry, FaqScope } from '@/seo/faqAssembly';

/**
 * FAQ 前台接口的等待上限（需求 6.10：「10 秒未返回」是判定失败的阈值，
 * 与 `src/api/request.ts` 的全站默认 15 秒不是同一个口径，这里用
 * axios 单次请求的 `timeout` 覆盖默认值）。
 */
const FAQ_REQUEST_TIMEOUT_MS = 10000;

/**
 * 拉取某个归属范围（Page_Type 或 `SITE`）下已发布的 FAQ_Entry 列表。
 *
 * 对应 `GET /api/front/faq?scope=...`（`FrontFaqController`），响应体为
 * `AjaxResult.success(list)` 形态（`{ code, msg, data }`），因此这里取
 * `res?.data` 并兜底为空数组，保证调用方（`FaqBlock.tsx`）拿到的恒是数组。
 *
 * 10 秒未返回或请求失败时，走 axios 的超时/拒绝路径，由调用方 `catch` 处理并
 * 整段省略 FAQ_Block（需求 6.10），本函数不在这里吞掉错误。
 *
 * @param scope 归属范围：某个 Page_Type 或 `SITE`
 */
export function getFrontFaq(scope: FaqScope): Promise<FaqEntry[]> {
  return service
    .get('/api/front/faq', { params: { scope }, timeout: FAQ_REQUEST_TIMEOUT_MS })
    .then((res: any) => {
      const data = res?.data ?? (Array.isArray(res) ? res : []);
      return Array.isArray(data) ? data : [];
    });
}
